module.exports = __webpack_public_path__ + "img/1504074205.6686600e.jpg";